import * as jsPDF from 'jspdf-with-html2canvas'
import moment from 'moment'
import {drilltecLogo, bsiCert} from './ReportImages'
import {message} from 'antd'
import $ from 'jquery'

export const ReportQualityPlan = (props) => {
  function date(date) {
    if (date) {
      var str = date.split("-");
      var fYear = str[0],
          fMonth = str[1],
          fDay = str[2];
          
      return fDay + "-" + fMonth + "-" + fYear;
    } else {
      return '';
    }
  }

  if (props.form_values['6f71']) {var rClient = props.form_values['6f71']} else rClient = '';
  if (props.form_values['b62d']) {var rTitle = props.form_values['b62d']} else rTitle = '';
  if (props.form_values['94d5']) {var rLocation = props.form_values['94d5']} else rLocation = '';
  if (props.form_values['63e7']) {var rPlannedBy = props.form_values['63e7']} else rPlannedBy = '';
  if (props.form_values['4071']) {var rApprovedBy = props.form_values['4071']} else rApprovedBy = '';
  if (props.form_values['b059']) {var rJobNumber = props.form_values['b059']} else rJobNumber = '';
  if (props.form_values['7677']) {var rBoreRequest = props.form_values['7677']} else rBoreRequest = '';
  if (props.form_values['1c05']) {var rBCLNumber = props.form_values['1c05']} else rBCLNumber = '';
  if (props.form_values['72a2']) {var rBoresWithin = props.form_values['72a2']} else rBoresWithin = '';

  //OFFICE MANAGER
  if (props.form_values['3707']) {var rDate1_1 = props.form_values['3707']} else rDate1_1 = '';
  if (props.form_values['6273']) {var rSign1_1 = props.form_values['6273'].choice_values[0]} else rSign1_1 = ''; 
  if (props.form_values['af80']) {var rDate1_2 = props.form_values['af80']} else rDate1_2 = '';
  if (props.form_values['15bf']) {var rSign1_2 = props.form_values['15bf'].choice_values[0]} else rSign1_2 = '';

  //PROJECT MANAGER
  if (props.form_values['e15b']) {var rDate2_1 = props.form_values['e15b']} else rDate2_1 = '';
  if (props.form_values['6766']) {var rSign2_1 = props.form_values['6766'].choice_values[0]} else rSign2_1 = ''; 
  if (props.form_values['c769']) {var rDate2_2 = props.form_values['c769']} else rDate2_2 = '';
  if (props.form_values['2e1b']) {var rSign2_2 = props.form_values['2e1b'].choice_values[0]} else rSign2_2 = '';

  //DRILLER
  if (props.form_values['ec15']) {var rDate3_1 = props.form_values['ec15']} else rDate3_1 = '';
  if (props.form_values['9ae5']) {var rSign3_1 = props.form_values['9ae5'].choice_values[0]} else rSign3_1 = ''; 
  if (props.form_values['83f8']) {var rDate3_2 = props.form_values['83f8']} else rDate3_2 = '';
  if (props.form_values['5630']) {var rSign3_2 = props.form_values['5630'].choice_values[0]} else rSign3_2 = '';
  if (props.form_values['5e22']) {var rDate3_3 = props.form_values['5e22']} else rDate3_3 = '';
  if (props.form_values['427d']) {var rSign3_3 = props.form_values['427d'].choice_values[0]} else rSign3_3 = ''; 
  if (props.form_values['8718']) {var rDate3_4 = props.form_values['8718']} else rDate3_4 = '';
  if (props.form_values['ab04']) {var rSign3_4 = props.form_values['ab04'].choice_values[0]} else rSign3_4 = '';
  if (props.form_values['67bd']) {var rDate3_5 = props.form_values['67bd']} else rDate3_5 = '';
  if (props.form_values['4414']) {var rSign3_5 = props.form_values['4414'].choice_values[0]} else rSign3_5 = ''; 
  if (props.form_values['9291']) {var rDate3_6 = props.form_values['9291']} else rDate3_6 = '';
  if (props.form_values['d60a']) {var rSign3_6 = props.form_values['d60a'].choice_values[0]} else rSign3_6 = '';
  if (props.form_values['80f0']) {var rDate3_7 = props.form_values['80f0']} else rDate3_7 = '';
  if (props.form_values['5630']) {var rSign3_7 = props.form_values['5630'].choice_values[0]} else rSign3_7 = '';

  //PROJECT MANAGER
  if (props.form_values['c990']) {var rDate4_1 = props.form_values['c990']} else rDate4_1 = '';
  if (props.form_values['5a3d']) {var rSign4_1 = props.form_values['5a3d'].choice_values[0]} else rSign4_1 = ''; 

  //ADMIN
  if (props.form_values['8ab2']) {var rDate5_1 = props.form_values['8ab2']} else rDate5_1 = '';
  if (props.form_values['0c2e']) {var rSign5_1 = props.form_values['0c2e'].choice_values[0]} else rSign5_1 = '';

  //FOOTER
  if (props.form_values['9ae5']) {var rDriller = props.form_values['9ae5'].choice_values[0]} else rDriller = '';
  if (props.form_values['d07f']) {var rComments = props.form_values['d07f']} else rComments = '';

  
  var doc = new jsPDF();

  //Header
  doc.addImage(drilltecLogo, 'JPEG', 20, 7, 24.3, 12)
  doc.setFontSize(15)
  doc.setFontStyle('bold');
  doc.text(90, 15, 'Quality Plan');
  doc.setFontStyle('normal');
  doc.setFontSize(10)
  doc.text(175, 15, 'QPpf-2-1');

  doc.setLineWidth(0.5);
  doc.line(20, 22, 190, 22);

  //Job info Left
  doc.setFontType('bold')
  doc.text(30, 29, 'Client Name:');
  doc.setFontType('normal')
  doc.text(60, 29, rClient);
  
  doc.setFontType('bold')
  doc.text(30, 35, 'Planned By:');
  doc.setFontType('normal')
  doc.text(60, 35, rPlannedBy);
  
  doc.setFontType('bold')
  doc.text(30, 41, 'Location:');
  doc.setFontType('normal')
  doc.text(33, 47, rLocation);
  
  doc.setFontType('bold')
  doc.text(30, 53, 'Job Title:');
  doc.setFontType('normal')
  doc.text(33, 59, rTitle);
  
  
  //Job info Right
  doc.setFontType('bold')
  doc.text(120, 29, 'Job Number:');
  doc.setFontType('normal')
  doc.text(152, 29, rJobNumber);
  
  doc.setFontType('bold')
  doc.text(120, 35, 'Bore Request:');
  doc.setFontType('normal')
  doc.text(152, 35, rBoreRequest);
  
  doc.setFontType('bold')
  doc.text(120, 41, 'BCL No:');
  doc.setFontType('normal')
  doc.text(152, 41, rBCLNumber);
  
  doc.setFontType('bold')
  doc.text(120, 47, 'Approved By:');
  doc.setFontType('normal')
  doc.text(152, 47, rApprovedBy);
  
  doc.setFontType('bold')
  doc.text(120, 53, 'Bores Within Job:');
  doc.setFontType('normal')
  doc.text(123, 59, rBoresWithin);
  
  doc.setLineWidth(0.3);
  doc.line(20, 62, 190, 62);

  //Body and checks
  //1.0
  doc.setFontStyle('bold')
  doc.text(25, 65 + 3, 'OFFICE MANAGER');
  //1.1
  doc.setFontStyle('normal');
  doc.text(30, 73 + 3, 'Received bore request and work order');
  doc.text(110, 73 + 3, date(rDate1_1));
  doc.text(140, 73 + 3, rSign1_1);
  //1.2
  doc.text(30, 80 + 3, 'Proposed Start Date');
  doc.text(110, 80 + 3, date(rDate1_2));
  doc.text(140, 80 + 3, rSign1_2);

  //2.0
  doc.setFontStyle('bold');
  doc.text(25, 90 + 3, 'PROJECT MANAGER');
  //2.1
  doc.setFontStyle('normal');
  doc.text(30, 98 + 3, 'Plan Job, access site and arrange pits etc');
  doc.text(110, 98 + 3, date(rDate2_1)); 
  doc.text(140, 98 + 3, rSign2_1);
  //2.2
  doc.text(30, 105 + 3, 'Hold discussions with driller');
  doc.text(110, 105 + 3, date(rDate2_2));
  doc.text(140, 105 + 3, rSign2_2);

  //3.0
  doc.setFontStyle('bold');
  doc.text(25, 115 + 3, 'DRILLER');
  //3.1       (+8)
  doc.setFontStyle('normal');
  doc.text(30, 123 + 3, 'Collect gear required from depot');
  doc.text(110, 123 + 3, date(rDate3_1));
  doc.text(140, 123 + 3, rSign3_1);
  //3.2       (+7)
  doc.text(30, 130 + 3, 'Start "Equipment inventory" report');
  doc.text(110, 130 + 3, date(rDate3_2)); // 50/50 CHANCE THESE ARNT SWAPPED
  doc.text(140, 130 + 3, rSign3_2);
  //3.3      (+7)
  doc.text(30, 137 + 3, 'Perform site safety checklist');
  doc.text(110, 137 + 3, date(rDate3_3)); // 50/50 CHANCE THESE ARNT SWAPPED
  doc.text(140, 137 + 3, rSign3_3);
  //3.4       (+7)
  doc.text(30, 144 + 3, 'Drill bore as per request and discussions');
  doc.text(110, 144 + 3, date(rDate3_4));
  doc.text(140, 144 + 3, rSign3_4);
  //3.5       (+7)
  doc.text(30, 151 + 3, 'Packup gear and clean site');
  doc.text(110, 151 + 3, date(rDate3_5));
  doc.text(140, 151 + 3, rSign3_5);
  //3.6       (+7)
  doc.text(30, 158 + 3, 'Complete "Site clearance report"');
  doc.text(110, 158 + 3, date(rDate3_6)); // CHECK (1/3)
  doc.text(140, 158 + 3, rSign3_6);
  //3.7       (+7)
  doc.text(30, 165 + 3, 'Job Completion');
  doc.text(110, 165 + 3, date(rDate3_7)); // CHECK (2/3)
  doc.text(140, 165 + 3, rSign3_7);

  //4.0       (+10)
  doc.setFontStyle('bold');
  doc.text(25, 175 + 3, 'PROJECT MANAGER');
  //4.1       (+8)
  doc.setFontStyle('normal');
  doc.text(30, 183 + 3, 'Hold post discussions with driller');
  doc.text(110, 183 + 3, date(rDate4_1)); //CHECK  (3/3)
  doc.text(140, 183 + 3, rSign4_1);

  //5.0       (+10)
  doc.setFontStyle('bold');
  doc.text(25, 193 + 3, 'ADMIN');
  //5.1       (+8)
  doc.setFontStyle('normal');
  doc.text(30, 201 + 3, 'Invoice client');
  doc.text(110, 201 + 3, date(rDate5_1));
  doc.text(140, 201 + 3, rSign5_1);

  //Line
  doc.setLineWidth(0.3);
  doc.line(20, 210, 190, 210);

  //top footer
  doc.text(30, 218, 'Driller:');
  doc.text(110, 218, rDriller);
  doc.text(30, 228, 'Comments:');
  doc.text(110, 228, rComments);

  //Footer footer
  doc.addImage(bsiCert, 'JPEG', 165, 260, 25.827, 12)
  doc.text(20, 285, 'Drilltec Pty Ltd');
  doc.text(95, 285, '12/09/2018');
  doc.text(175, 285, 'QPpf-2-1');


  doc.addPage();
  doc.text(20, 20, "this is the second page.")

  doc.addHTML($('#boresTableThree').get(0),20, 20, {
    'width':500
  });


  //Save PDF eg: 1907__02-05-2018.pdf
  var now = moment().format('DD-MM-YYYY');
  doc.save(rJobNumber + '__' + now + '.pdf');

  message.success('Quality plan has been downloaded.');
}